import { UserService } from './user-service';
import { CoreAPI } from './CoreAPI';
import { OffersService } from './offers-service';
import { DeviceService } from './device-service';

export default {
    UserService,
    CoreAPI,
    coreAPIInstance: new CoreAPI(),
    OffersService,
    DeviceService
};
